"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/* eslint-disable no-param-reassign */
var _ = require('lodash');
var _require = require('bson'),
  ObjectId = _require.ObjectId;
var FINDING_STATUSES = require('../../../common/constant/finding-status.constant');
var FINDING_VALUES = require('../../../common/constant/finding-value.constant');
var _require2 = require('../../../common/constant/report-status.constant'),
  DONE = _require2.DONE,
  SENT_TO_RP = _require2.SENT_TO_RP;
module.exports = /*@ngInject*/function ($location, $q, $scope, $rootScope, $uibModal, currentUser, report, findingId, incidentId, Upload, ReportService, PartyService, ChecklistService, RoutingGroupService, IDLE_TIMEOUT_WARNING, IdleHelper) {
  var ctrl = this;
  // eslint-disable-next-line no-undef
  var Amplify = window.aws_amplify;
  ctrl.reportStatuses = {
    SENT_TO_RP: SENT_TO_RP
  };
  ctrl.findingValues = FINDING_VALUES;
  ctrl.findingStatuses = FINDING_STATUSES;
  ctrl.findingValueOptions = ReportService.findingValueOptions;
  ctrl.getAcceptedAttachmentFormats = ReportService.ACCEPTED_ATTACHMENT_FORMATS;

  // eslint-disable-next-line no-undef
  ctrl.isDownloadSupported = function () {
    return !!new Blob();
  };
  ctrl.files = [];
  ctrl.errorFiles = [];
  ctrl.defaultIdleTimeout = null;
  ctrl.defaultIdleWarn = null;
  ctrl.defaultIdleStart = null;
  ctrl.uploadProgress = false;
  ctrl.init = function () {
    ctrl.report = report;
    ctrl.readOnly = report.status === SENT_TO_RP || report.status === DONE;
    ctrl.finding = _.find(report.findings, {
      id: findingId
    });
    ctrl.incident = _.find(ctrl.finding.incidents, {
      id: incidentId
    }) || ctrl.newIncident();
    ctrl.incident.value = ctrl.incident.value || ctrl.findingValues.NOT_COMPLIANT;
    ctrl.incident.status = ctrl.incident.status || ctrl.findingStatuses.NOT_RESOLVED;
    ctrl.category = ctrl.report.categories.find(function (category) {
      return category.name === ctrl.incident.category;
    });
    ctrl.routingGroups = [];
    ctrl.recentAttachments = [];
    ctrl.findingValueOptions = ReportService.getFindingValueOptions(ctrl.findingValueOptions, ctrl.finding.type);
    if (ctrl.incident) {
      ctrl.incident.deletedAttachments = [];
    }
    ChecklistService.get({
      id: ctrl.report.configuration.checklist
    }, function (checklist) {
      ctrl.checklist = checklist;
      ctrl.tags = _.union(checklist.tags, ctrl.incident.tags);
    });
    if (ctrl.report.configuration.routingGroup) {
      RoutingGroupService.get({
        id: ctrl.report.configuration.routingGroup
      }).$promise.then(function (routingGroup) {
        ctrl.routingGroups = routingGroup.groups.map(function (group) {
          return group.name;
        });
      });
    }
    var query = ctrl.buildLocationQuery();
    if (query) {
      PartyService.getLocations(query, function (locations) {
        ctrl.locations = locations;
      });
    }
    $location.search('status', null);
  };
  ctrl.saveEdit = function () {
    var signout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    ctrl.progress = true;
    // eslint-disable-next-line prefer-object-spread
    var incidentPayload = Object.assign({}, ctrl.incident);
    if (![SENT_TO_RP, DONE].includes(ctrl.report.status)) {
      incidentPayload.tags = _.map(ctrl.incident.tags, 'text');
      incidentPayload.meta.touched = true;
    }
    ReportService.removeUnsavedAttachments(ctrl.recentAttachments, ctrl.incident.attachments);
    incidentPayload.routingGroups = _.map(ctrl.incident.routingGroups, 'text').filter(Boolean);
    ReportService.updateIncident({
      id: ctrl.report._id,
      findingId: ctrl.finding.id,
      incidentId: ctrl.incident.id
    }, incidentPayload).$promise.then(function () {
      if (signout) {
        Amplify.Auth.signOut();
      } else {
        $location.path("/report/".concat(ctrl.report._id)).search({
          activeIncidentId: ctrl.incident.id,
          catName: ctrl.category.name
        });
      }
    });
  };
  ctrl.cancel = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!ctrl.recentAttachments.length) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return Promise.all(ctrl.recentAttachments.map(function (attachment) {
            return ReportService.deleteAttachment({
              name: attachment.s3Name
            });
          }));
        case 3:
          $location.path("/report/".concat(ctrl.report._id)).search({
            activeIncidentId: ctrl.incident.id
          });
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  ctrl["delete"] = function () {
    ctrl.deleteProgress = true;
    ReportService.deleteIncident({
      id: ctrl.report._id,
      findingId: ctrl.finding.id,
      incidentId: ctrl.incident.id
    }).$promise.then(function () {
      $location.path("/report/".concat(ctrl.report._id)).search({
        activeFindingId: ctrl.finding.id
      });
    })["catch"](function () {
      ctrl.deleteProgress = false;
    });
  };
  ctrl.addAttachments = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(ctrl.files && ctrl.files.length)) {
            _context3.next = 4;
            break;
          }
          ctrl.uploadProgress = true;
          _context3.next = 4;
          return Promise.allSettled(ctrl.files.map(/*#__PURE__*/function () {
            var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(file) {
              var fileType, _yield$ReportService$, uploadedFile, error, _yield$ReportService$2, signedUrl, attachment;
              return _regenerator["default"].wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    fileType = file.type && file.type.indexOf('image') > -1 ? 'IMAGE' : 'DOCUMENT';
                    _context2.next = 3;
                    return ReportService.uploadFile(file);
                  case 3:
                    _yield$ReportService$ = _context2.sent;
                    uploadedFile = _yield$ReportService$.uploadedFile;
                    error = _yield$ReportService$.error;
                    if (!error) {
                      _context2.next = 11;
                      break;
                    }
                    ctrl.errorFiles.push({
                      fileName: file.name,
                      error: error
                    });
                    _.remove(ctrl.files, _.find(ctrl.files, file));
                    _context2.next = 20;
                    break;
                  case 11:
                    _context2.next = 13;
                    return ReportService.downloadFile(uploadedFile.name);
                  case 13:
                    _yield$ReportService$2 = _context2.sent;
                    signedUrl = _yield$ReportService$2.signedUrl;
                    _context2.next = 17;
                    return ReportService.createAttachmentData(uploadedFile, signedUrl, fileType);
                  case 17:
                    attachment = _context2.sent;
                    ctrl.incident.attachments.push(attachment);
                    ctrl.recentAttachments.push(attachment);
                  case 20:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }()));
        case 4:
          ctrl.uploadProgress = false;
          ctrl.files = [];
          ctrl.errorFiles = [];
          if (!$scope.$$phase) $scope.$apply();
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  ctrl.deleteAttachment = function (attachment) {
    var index = ctrl.incident.attachments.findIndex(function (incidentAttachment) {
      if (attachment.id) {
        // attachment hasn't been submitted to server yet
        return attachment.id === incidentAttachment.id;
      }
      if (attachment.attachmentId) {
        // attachment is either thumbnail or a document, not retrieved from server
        return attachment.attachmentId === incidentAttachment.attachmentId;
      }
      // attachment is retrieved from server
      return attachment._id === incidentAttachment.attachmentId;
    });
    ctrl.incident.attachments.splice(index, 1);
  };
  ctrl.getResults = function (query, array) {
    return _.filter(array, function (result) {
      return result.toLowerCase().indexOf(query.toLowerCase()) > -1;
    });
  };
  ctrl.updateIncidentValueAndStatus = function (value, status) {
    ctrl.incident.value = value;
    ctrl.incident.status = status;
    if (value !== ctrl.findingValues.NOT_COMPLIANT) {
      ctrl.incident.correctedOnSite = false;
    }
  };
  ctrl.setLightbox = function (attachment) {
    ctrl.lightbox = attachment;
  };
  ctrl.buildLocationQuery = function () {
    var query = {
      party: report.party
    };
    if (report.configuration.partyToLocation) {
      query.partyToLocationId = report.configuration.partyToLocation;
    } else if (report.configuration.location) {
      query.locationId = report.configuration.location;
    }
    return query.partyToLocationId || query.locationId ? query : undefined;
  };
  ctrl.newIncident = function () {
    return ReportService.initializeIncident(ctrl.finding, $location.search().category, $location.search().status, currentUser, new ObjectId().toString(), ctrl.report.configuration.verificationDefaultValue);
  };
  ctrl.onCorrectedOnSiteChange = function () {
    if (ctrl.incident.correctedOnSite) {
      ctrl.updateIncidentValueAndStatus(ctrl.findingValues.NOT_COMPLIANT, ctrl.findingStatuses.RESOLVED);
    } else {
      ctrl.incident.status = ctrl.incident.value === ctrl.findingValues.NOT_COMPLIANT ? ctrl.findingStatuses.NOT_RESOLVED : ctrl.incident.value;
    }
  };
  ctrl.setUpTimeout = function () {
    ctrl.defaultIdleTimeout = $rootScope.$$listeners.IdleTimeout.pop();
    ctrl.defaultIdleWarn = $rootScope.$$listeners.IdleWarn.pop();
    ctrl.defaultIdleStart = $rootScope.$$listeners.IdleStart.pop();
    IdleHelper.setUpTimeout(function () {
      return ctrl.saveEdit(true);
    });
  };
  $scope.$on('$destroy', function () {
    $rootScope.$$listeners.IdleTimeout = [ctrl.defaultIdleTimeout];
    $rootScope.$$listeners.IdleWarn = [ctrl.defaultIdleWarn];
    $rootScope.$$listeners.IdleStart = [ctrl.defaultIdleStart];
  });
  ctrl.init();
  ctrl.setUpTimeout();
};